"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _DragAndDrop = require("./DragAndDrop");
var _InlineWysiwyg = _interopRequireDefault(require("./InlineWysiwyg"));
var _SectionTitle = _interopRequireDefault(require("./SectionTitle"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FinalTestInstructions = function FinalTestInstructions(_ref) {
  var formProps = _ref.formProps;
  var setBullets = function setBullets(bullets) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        finalTestInstructions: _objectSpread(_objectSpread({}, formProps.values.courseDescription.finalTestInstructions), {}, {
          bullets: bullets
        })
      })
    }));
  };
  var onDragEnd = function onDragEnd(result) {
    if (!result.destination || !result.source) {
      return;
    }
    var fromIndex = result.source.index;
    var toIndex = result.destination.index;
    var bullets = (0, _DragAndDrop.dndSwap)(formProps.values.courseDescription.finalTestInstructions.bullets.map(function (bullet) {
      return _objectSpread({}, bullet);
    }), fromIndex, toIndex);
    setBullets(bullets);
  };
  var onClickAdd = function onClickAdd() {
    var bullets = _toConsumableArray(formProps.values.courseDescription.finalTestInstructions.bullets);
    var highestKey = 0;
    bullets.forEach(function (bullet) {
      if (bullet.key > highestKey) {
        highestKey = bullet.key;
      }
    });
    bullets.push({
      text: '',
      key: highestKey + 1
    });
    setBullets(bullets);
  };
  var onClickDelete = function onClickDelete(key) {
    var bullets = formProps.values.courseDescription.finalTestInstructions.bullets.filter(function (bullet) {
      return bullet.key !== key;
    });
    setBullets(bullets);
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "Final Test Instructions"), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: "finalTestInstructions",
    placeholder: "Final Test Instructions"
  }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
    name: "courseDescription.finalTestInstructions.statement",
    label: "Statement"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label"
  }, "Instruction Bullets"), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "course-wrapper-finalTestInstructions"
  }, function (dropProvided, dropSnapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, dropProvided.droppableProps, {
      ref: dropProvided.innerRef
    }), dropProvided.placeholder, formProps.values.courseDescription.finalTestInstructions.bullets.map(function (bullet, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: "finalTestInstructions-bullet-".concat(bullet.key),
        index: index,
        key: "finalTestInstructions-bullet-".concat(bullet.key)
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, dragProvided.dragHandleProps, {
          className: _style["default"].dragContainer
        }), dragProvided.placeholder, /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndArrows, null), /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_style["default"].dragAndDropContent, " ").concat(_style["default"].removeMargin)
        }, /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.finalTestInstructions.bullets[".concat(index, "].text")
        })), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndDeleteButton, {
          onClick: function onClick() {
            return onClickDelete(bullet.key);
          }
        }));
      });
    }));
  })), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndAddButton, {
    onClick: onClickAdd
  })));
};
var _default = exports["default"] = FinalTestInstructions;